<!-- 学生主页 -->
<template>
  <div class="mentee-mian">
    <!-- 头部 -->
    <div class="mentee-top">
      <div class="mentee-top-detail">
        <!-- 信息 -->
        <mentee-detail :id="id"></mentee-detail>
      </div>
      <div class="mentee-top-menu">
        <!-- 导航 -->
        <menu-row :menuList="menuList"></menu-row>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
// less
import './mentee.less'
// components
import MenuRow from '_c/menu-row/menu-row'
import MenteeDetail from './components/mentee-detail'
import { mapState } from 'vuex'
export default {
  name: 'mentee-mian',
  components: {
    MenuRow,
    MenteeDetail
  },
  data () {
    return {
      id: this.$route.params.id,
      menuList: [
        {
          title: 'Activities',
          name: ['mentee-activities']
        },
        {
          title: 'Information',
          name: ['mentee-info']
        }
      ]
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.showMenu()
  },
  methods: {
    showMenu () {
      if (!this.userRole) return false
      let role = this.userRole
      let menuArr = []
      switch (role) {
        case 'SM':
          menuArr = [
            {
              title: 'Appointment',
              name: ['mentee-appointment', 'mentee-zoom']
            },
            {
              title: 'Program',
              name: ['mentee-program', 'mentee-program-main']
            }
          ]
          break
        case 'CM':
          menuArr = [
            {
              title: 'Appointment',
              name: ['mentee-appointment', 'mentee-zoom']
            }
          ]
          break
        case 'EM':
          menuArr = [
            {
              title: 'Program',
              name: ['mentee-program', 'mentee-program-main']
            },
            {
              title: 'CV / RL',
              name: ['mentee-cv-rl', 'mentee-cvrl-cv-detail', 'mentee-cvrl-rl-detail']
            }
          ]
          break
      }
      this.menuList.push(...menuArr)
    }
  },
  watch: {
    userRole () {
      this.showMenu()
    }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.id = this.$route.params.id
  }
}
</script>
<style lang='less' scoped>
</style>
